import React, { useState, forwardRef, useEffect, useCallback } from "react";
import "./choose_method.css";
import "./BucketListAddition.css";
import Calendar from "../logo/Calendar.svg";
import DatePicker from "react-datepicker";
import { PriceLabel } from "../common/PriceLabel";
import FiveStarComponent from "../common/FiveStarComponent";
import { ReactComponent as PlusIcon } from "../logo/PaperPlus.svg";
import { useAlert } from "react-alert";

function BucketListAddition(props) {
  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());
  const { formatFullDate } = require("node-format-date");
  const [conflict, setConflict] = useState(false);
  const alert = useAlert();

  const ExampleCustomInput = forwardRef(({ onClick }, ref) => (
    <button className="calendar" onClick={onClick} ref={ref}>
      <img src={Calendar} onClick={onClick} alt="calendar"></img>
    </button>
  ));

  const onChangeDate = (date) => {
    setStartTime(date);
    setEndTime(date);
  };

  const isInvalidRange = useCallback(
    (value) => {
      if (startTime.getTime() >= endTime.getTime()) {
        setConflict(true);
      } // eslint-disable-next-line
    },
    [startTime, endTime]
  );

  const checkConflictAll = useCallback(
    (value) => {
      setConflict(false);
      isInvalidRange();
    },
    [isInvalidRange]
  );

  useEffect(() => {
    checkConflictAll();
  }, [startTime, endTime, alert, checkConflictAll]);

  const handleClick = () => {
    if (conflict === true) {
      alert.error(
        "Gagal menambahkan! Jam mulai harus lebih awal dari Jam selesai"
      );
    } else {
      props.addPoi(props.poi, startTime, endTime);
      props.filter();
    }
  };

  return (
    <div className="itin-poi-item-container" testid="itin-poi-item">
      <img
        src={props.poi.image_url}
        alt={`itin-poi-item-${props.id}`}
        className="poi-img"
      />
      <div className="itin-poi-item-details-container flex-column flex-md-row align-items-start align-items-md-center">
        <div>
          <div className="itin-poi-item-name headline add-from-bucketlist">
            {props.poi.name}
          </div>
          <div className="star-bucket">
            <FiveStarComponent
              className="itin-poi-review-container"
              editable={false}
              value={props.poi.rating.rating}
            />
          </div>
          <div className="price-bucket">
            <PriceLabel
              min={props.poi.min_spending}
              max={props.poi.max_spending}
              suffix=" / orang"
            />
          </div>
          <div className="d-flex">
            <DatePicker
              selected={startTime}
              onChange={(date) => onChangeDate(date)}
              closeOnScroll={true}
              customInput={<ExampleCustomInput />}
              dateFormat="MMMM d, yyyy h:mm aa"
              minDate={new Date()}
            />

            <h5 className="blue">{formatFullDate(startTime)}</h5>
          </div>
          <div className="d-flex">
            <DatePicker
              className="form-control time h5 me-2"
              selected={startTime}
              onChange={(date) => setStartTime(date)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
            />
            <span> - </span>
            <DatePicker
              className="form-control time h5 ms-2"
              selected={endTime}
              onChange={(date) => setEndTime(date)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
            />
          </div>
        </div>
        <button
          className="primary-button add-poi-bucket-button"
          data-testid="add-itin-button"
          //onClick={() => props.addPoi(props.poi, startTime, endTime)}
          onClick={handleClick}
        >
          <PlusIcon />
          <span className="simpan-text">Tambah ke Itinerary</span>
        </button>
      </div>

      {/* <div className="d-flex justify-content-center warn">
        {conflict && <h4 className="mt-3">{message} </h4>}
        </div> */}
    </div>
  );
}

export default BucketListAddition;
